import React, { useState, useCallback } from 'react';
import TrainTrackingContext from './TrainTrackingContext';
import { searchTrain } from '../../services/train-tracking/trainService';
import { parseStandardDate } from '../../components/forms/CustomDatePicker';

const TrainTrackingState = (props) => {
  const [trainData, setTrainData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const trackTrain = useCallback(async (trainNumber, journeyDate) => {
    setLoading(true);
    setError(null);
    try {
      let formattedDate = journeyDate;
      if (journeyDate) {
        const parsed = parseStandardDate(journeyDate) || new Date(journeyDate);
        if (parsed && !isNaN(parsed.getTime())) {
          formattedDate = `${parsed.getFullYear()}-${String(parsed.getMonth() + 1).padStart(2, '0')}-${String(parsed.getDate()).padStart(2, '0')}`;
        }
      }
      const data = await searchTrain(trainNumber, formattedDate);
      if (data.success && data.data) {
        setTrainData(data.data.response || data.data);
      } else {
        setTrainData(null);
        setError('No train data found.');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to fetch train status.');
      setTrainData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const clearTrainData = useCallback(() => {
    setTrainData(null);
    setError(null);
  }, []);

  return (
    <TrainTrackingContext.Provider
      value={{
        trainData,
        loading,
        error,
        trackTrain,
        clearTrainData
      }}
    >
      {props.children}
    </TrainTrackingContext.Provider>
  );
};

export default TrainTrackingState;
